import * as React from "react";

export function useItemsById<T extends { id: number }>(
  items: T[]
): Map<number, T> {
  return React.useMemo(() => {
    const map = new Map<number, T>();
    for (const item of items) {
      map.set(item.id, item);
    }
    return map;
  }, [items]);
}

export function useSelectedItems<T extends { id: number }>(
  selectedIds: number[] | undefined,
  items: T[]
) {
  const byId = useItemsById(items);

  const idSet = React.useMemo(
    () => new Set(selectedIds || []),
    [selectedIds]
  );

  const selectedItems = React.useMemo(() => {
    if (!selectedIds) return [];
    return selectedIds
      .map((id) => byId.get(id))
      .filter((item): item is T => item != null);
  }, [selectedIds, byId]);

  return { idSet, byId, selectedItems };
}
